import React from 'react';
import PropTypes from 'prop-types';

export var Mailto = function Mailto(_ref) {
  var emailAddress = _ref.emailAddress;
  return React.createElement(
    'a',
    { href: 'mailto:' + emailAddress },
    emailAddress
  );
};

Mailto.displayName = 'Mailto';

Mailto.propTypes = process.env.NODE_ENV !== "production" ? {
  emailAddress: PropTypes.string.isRequired
} : {};

export default Mailto;